<template>
  <b-row>
    <div class="spinner-container" style="margin: auto;">
      <div id="spinner"></div>
      <p class="title-text">{{lang=='en' ? 'Uploading image ...':'이미지 업로드 중 ...'}}</p>
    </div>
  </b-row>
</template>

<script>
export default {
  name: 'ImageUploadingPageView',

  props: {
    lang: {
      type: String,
      required: true
    },
  },
}
</script>